<template>
  <div id="dataDetail" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div class="flex">
        <!-- 筛选标准，实体，关键字-->
        <selectStandardId @updateStandardId="updateStandardId" />
        <selectTree
          :standardId="standardId"
          @selectNode="changeEntityData"
          ref="selectTree"
          class="mx-10px"
        />
        <!-- <el-select
          size="small"
          clearable
          filterable
          v-model="classId"
          :placeholder="$t('pleaseSelectClass')"
          class="w-200px mr-10px"
          :disabled="!classList.length"
          @change="changeClassId"
        >
          <el-option
            v-for="(item, index) in classList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select> -->
        <el-select
          size="small"
          clearable
          filterable
          v-model="attrId"
          :placeholder="`${$t('pleaseSelectAttr')}`"
          class="w-200px mr-10px"
          @change="changeAttr(attrId)"
        >
          <el-option
            v-for="item in attrList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          size="small"
          filterable
          v-model="symbolValue"
          v-if="selectedAttrType !== 11"
          :placeholder="`${$t('pleaseSelect')}`"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="(item, index) in symbolList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          size="small"
          class="w-200px mr-10px"
          v-model.trim="keyword"
          :placeholder="`${$t('pleaseEnterKeyWords')}`"
          v-if="selectedAttrType === 1 || selectedAttrType === 10"
          clearable
        ></el-input>
        <el-select
          size="small"
          clearable
          v-if="selectedAttrType === 11"
          filterable
          v-model="keyword"
          :placeholder="$t('pleaseChoose')"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="item in labelArr"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
        <el-input-number
          v-else-if="selectedAttrType === 2 || selectedAttrType === 3"
          v-model="keyword"
          clearable
          :controls="false"
          class="w-200px mr-10px"
        ></el-input-number>
        <el-time-picker
          v-else-if="selectedAttrType === 9"
          v-model.trim="keyword"
          class="w-200px mr-10px"
          :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
          value-format="HH:mm:ss"
          :placeholder="`${$t('selectTime')}`"
        ></el-time-picker>
        <el-date-picker
          v-else-if="selectedAttrType === 8"
          v-model.trim="keyword"
          class="w-200px mr-10px"
          value-format="yyyy-MM-dd"
          type="date"
          :placeholder="`${$t('selectDate')}`"
        ></el-date-picker>
        <el-date-picker
          v-else-if="selectedAttrType === 6"
          v-model.trim="keyword"
          class="w-200px mr-10px"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="`${$t('selectTime')}`"
        ></el-date-picker>
        <!-- 搜索 -->
        <el-button type="primary" @click="searchCodeList('search')">{{ $t('search') }}</el-button>
        <el-button type="primary" @click="toMoreSearch">高级查询</el-button>
        <!-- 新增编码-->
        <el-button
          type="primary"
          @click="addEntity({}, 'add')"
          :disabled="
            ['Tag', 'Document'].includes(currentTreeSelected.code) || !$hasAccess('create')
          "
          >{{ $t('create') }}</el-button
        >
        <el-button
          type="danger"
          :disabled="!$hasAccess('delete')"
          @click="deleteDynamicData(selectedRows)"
          >{{ $t('delete') }}</el-button
        >
        <el-button
          :disabled="!$hasAccess('export')"
          @click="exportExcel"
          :loading="exportLoading"
          >{{ $t('export') }}</el-button
        >
        <el-button :disabled="!$hasAccess('import')" @click="importFile">{{
          $t('import')
        }}</el-button>
        <!-- <columnVisible
          :options="columnVisibleOptions"
          ref="columnVisible"
          class="dib ml-10px"
          :name="['dataDetailColumnVisible']"
          :defaultValue="columnVisible"
          @columnVisibleChanged="changeColumn"
        ></columnVisible> -->
      </div>
      <el-row :gutter="20" class="h-full">
        <el-col
          :span="6"
          class="h-[calc(100%-56px)] border-1px mt-20px relative"
          v-show="isShowTreeMode"
        >
          <div class="my-20px flex justify-between">
            <div class="border-l-3 border-color-primary flex-1 pl-10px text-16px">实体列表</div>
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="iconfont icon-line-moreVertical text-14px font-bold !text-[#606266]"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="operateTree(true)">
                  {{ $t('expandAll') }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="operateTree(false)">
                  {{ $t('collapseThemAll') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="mb-20px flex">
            <el-input
              size="small"
              class="mr-10px"
              v-model="classKeyword"
              :placeholder="`${$t('pleaseEnterCodeOrName')}`"
              clearable
            ></el-input>
            <el-button type="primary" @click="getClassTreeList">{{ $t('search') }}</el-button>
          </div>
          <div class="w-full h-[calc(100%-120px)] overflow-y-auto">
            <el-tree
              v-if="treeStandBy"
              ref="classTree"
              class="w-full h-full"
              :data="tableClassData"
              :props="classPros"
              :load="loadClassTreeNode"
              :expand-on-click-node="true"
              :default-expand-all="isExpandAll"
              @node-click="classNodeClick"
              lazy
              highlight-current
              node-key="id"
            >
              <div slot-scope="{ node, data }" class="w-full text-overflow">
                <el-tooltip
                  placement="top"
                  :content="`${node.label}（${data.name}）`"
                  :disabled="isShowTooltip"
                >
                  <span
                    class="text-overflow"
                    :class="`treeTooltip${data.id}`"
                    @mousemove="classTreeMouseOver(`treeTooltip${data.id}`)"
                  >
                    {{ node.label }}({{ data.name }})
                  </span>
                </el-tooltip>
              </div>
            </el-tree>
          </div>
          <div v-if="isShowTreeMode" class="absolute right-0 top-1/2" @click="changeTreeMode">
            <i class="iconfont icon-bg-circleLeft text-24px"></i>
          </div>
        </el-col>
        <el-col :span="isShowTreeMode ? 18 : 24" class="h-full relative">
          <div
            class="absolute left-[-10px] top-1/2 z-999"
            v-if="!isShowTreeMode"
            @click="changeTreeMode"
          >
            <i class="iconfont icon-bg-circleRight text-24px"></i>
          </div>
          <!-- 动态列表格-->
          <vxe-table
            :loading="listLoading"
            :data="valueList"
            class="mt-20px"
            ref="table"
            style="height: calc(100% - 106px)"
            border
            :row-config="{ isHover: true }"
            :column-config="{ resizable: true }"
            :checkbox-config="{ highlight: true }"
            :virtual-y-config="{ enabled: true, gt: 0 }"
            @sort-change="sortChangeVxe"
            @checkbox-change="handleSelectionChangeVxe"
            @checkbox-all="handleSelectionChangeVxe"
            show-overflow="title"
          >
            <vxe-table-column
              type="checkbox"
              width="40"
              align="center"
              fixed="left"
              v-if="tableHeader.length"
            ></vxe-table-column>
            <vxe-table-column
              type="seq"
              width="60"
              sortable
              fixed="left"
              align="center"
              :title="`${$t('seqNo')}`"
              v-if="tableHeader.length"
            ></vxe-table-column>
            <vxe-table-column
              v-for="(val, index) in tableHeader"
              :field="`${val.tableName}.${val.columnName}`"
              :key="val.name + index"
              :title="val.name"
              min-width="150"
            >
              <template #default="{ row }">
                <div
                  @click="operateTableList(row, tableHeader[index].name, tableHeader[index].column)"
                  v-if="computeOperataTableList(row, tableHeader[index].name)"
                  :class="
                    computeOperataTableList(row, tableHeader[index].name)
                      ? 'underline cur-pointer'
                      : ''
                  "
                >
                  {{ row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`] }}
                </div>
                <div v-else-if="tableHeader[index].isOperate">
                  <span>{{
                    row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`]
                  }}</span>
                  <el-tooltip
                    :content="$t('查看文件')"
                    v-if="showViewBtn(tableHeader[index])"
                    class="ml-10px"
                  >
                    <el-button
                      class="iconfont icon-line-show"
                      size="mini"
                      @click="
                        viewFile(
                          row,
                          'isView',
                          `${tableHeader[index].tableName}.${tableHeader[index].columnName}`
                        )
                      "
                    ></el-button>
                  </el-tooltip>
                </div>
                <div v-else-if="tableHeader[index].valueType === 13">
                  {{
                    row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`] &&
                      row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`]
                        .map((item) => {
                          return item.file
                        })
                        .join('，')
                  }}
                </div>
                <div v-else class="truncate">
                  {{ row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`] }}
                  <span
                    v-if="
                      tableHeader[index].unit &&
                        row[`${tableHeader[index].tableName}.${tableHeader[index].columnName}`]
                    "
                    >{{ tableHeader[index].unit }}</span
                  >
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              :title="`${$t('operate')}`"
              v-if="tableHeader.length"
              :width="isAttachment ? 280 : 200"
              fixed="right"
              :class-name="(isAttachment ? 'w-280px' : 'w-200px') + ' right-fixed-row'"
              :header-class-name="(isAttachment ? 'w-280px' : 'w-200px') + ' right-fixed-row'"
            >
              <template #default="{ row }">
                <el-button
                  :disabled="!$hasAccess('read')"
                  size="mini"
                  @click="addEntity(row, 'read')"
                  >{{ $t('view') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="addEntity(row, 'edit')"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="deleteDynamicData([row])"
                  >{{ $t('delete') }}</el-button
                >
                <el-button size="mini" v-if="isAttachment" @click="viewAttachments(row)"
                  >查看附件</el-button
                >
              </template>
            </vxe-table-column>
          </vxe-table>
          <!-- <el-table
            class="mt-20px"
            ref="table"
            :data="valueList"
            v-loading="listLoading"
            border
            :highlight-current-row="true"
            @sort-change="sortChangeLog"
            height="calc(100% - 106px)"
            @selection-change="handleSelectionChange"
            row-key="id"
          >
            <el-table-column
              v-if="tableHeader.length"
              fixed
              :reserve-selection="true"
              type="selection"
              width="40"
            ></el-table-column>
            <el-table-column
              type="index"
              v-if="tableHeader.length"
              width="60"
              :label="`${$t('seqNo')}`"
              sortable
            ></el-table-column>
            <el-table-column
              v-for="(val, index) in tableHeader"
              :prop="`${val.tableName}.${val.columnName}`"
              sortable="custom"
              show-overflow-tooltip
              :key="index"
              :label="val.name"
              min-width="150"
            >
              <template slot-scope="scope">
                <div
                  @click="operateTableList(scope.row, val.name, val.column)"
                  v-if="computeOperataTableList(scope.row, val.name)"
                  :class="
                    computeOperataTableList(scope.row, val.name) ? 'underline cur-pointer' : ''
                  "
                >
                  {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                </div>
                <div v-else-if="val.isOperate">
                  <span>{{ scope.row[`${val.tableName}.${val.columnName}`] }}</span>
                  <el-tooltip :content="$t('查看文件')" v-if="showViewBtn(val)" class="ml-10px">
                    <el-button
                      class="iconfont icon-line-show"
                      size="mini"
                      @click="viewFile(scope.row, 'isView', `${val.tableName}.${val.columnName}`)"
                    ></el-button>
                  </el-tooltip>
                </div>
                <div v-else-if="val.valueType === 13">
                  {{
                    scope.row[`${val.tableName}.${val.columnName}`] &&
                      scope.row[`${val.tableName}.${val.columnName}`]
                        .map((item) => {
                          return item.file
                        })
                        .join('，')
                  }}
                </div>
                <div v-else class="truncate">
                  {{ scope.row[`${val.tableName}.${val.columnName}`] }}
                  <span v-if="val.unit && scope.row[`${val.tableName}.${val.columnName}`]">{{
                    val.unit
                  }}</span>
                </div>
                {{ val }}
              </template>
            </el-table-column>
            <el-table-column
              :label="`${$t('operate')}`"
              v-if="tableHeader.length"
              :width="isAttachment ? 280 : 200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('read')"
                  size="mini"
                  @click="addEntity(scope.row, 'read')"
                  >{{ $t('view') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('update')"
                  size="mini"
                  @click="addEntity(scope.row, 'edit')"
                  >{{ $t('edit') }}</el-button
                >
                <el-button
                  :disabled="!$hasAccess('delete')"
                  size="mini"
                  @click="deleteDynamicData([scope.row])"
                  >{{ $t('delete') }}</el-button
                >
                <el-button size="mini" v-if="isAttachment" @click="viewAttachments(scope.row)"
                  >查看附件</el-button
                >
              </template>
            </el-table-column>
          </el-table> -->
          <!-- 分页-->
          <div class="mt-20px float-right pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="pageNo"
              :page-size="pageSize"
              :page-sizes="$pageSizeAll"
              layout="total, sizes, prev, pager, next"
              :total="recordCount"
            ></el-pagination>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 新增编辑弹框--新 -->
    <HandoverFormDialog
      v-if="handoverFormProps.dialogVisible"
      :handoverFormProps="handoverFormProps"
      @handoverFormEmit="handoverFormEmit"
    />

    <!-- 新增编码弹窗-->
    <el-dialog
      :title="title"
      :visible.sync="isShowDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      class="mid-dialog"
      v-dialogDrag
    >
      <div class="dialog w-full h-full pl-10px pr-10px overflow-y-auto overflow-x-hidden">
        <div id="uniqueCode">
          <el-table
            :data="attributeList"
            v-loading="listLoading"
            border
            :highlight-current-row="true"
            @selection-change="selectionChangeLog"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
            stripe
          >
            <el-table-column
              type="index"
              width="65"
              :label="`${$t('seqNo')}`"
              sortable="custom"
            ></el-table-column>
            <el-table-column prop="name" :label="`${$t('classAttrName')}`" sortable="custom">
              <template slot-scope="scoped">
                <div>
                  <span v-if="scoped.row.isNullable" style="color: red">*</span>
                  {{ scoped.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="code"
              :label="`${$t('classAttrCode')}`"
              sortable="custom"
            ></el-table-column>
            <el-table-column :label="`${$t('classAttrValue')}`" sortable="custom">
              <template slot-scope="scope">
                <div v-if="scope.row.isOperate">
                  <span @click="operateColumn(scope.row)" class="cur-pointer underline">
                    {{ scope.row.value }}
                  </span>
                  <el-tooltip
                    :content="$t('uploadFile')"
                    v-if="showUploadBtn(scope.row) && _.includes(['edit', 'add'], type)"
                    class="ml-10px"
                  >
                    <el-button
                      class="iconfont icon-line-upload"
                      size="mini"
                      @click="uploadFile(scope.row, scope.row.code)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    :content="$t('查看文件')"
                    v-if="showViewBtn(scope.row) && _.includes(['edit', 'read'], type)"
                    class="ml-10px"
                  >
                    <el-button
                      class="iconfont icon-line-show"
                      type="primary"
                      size="mini"
                      @click="viewFile(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    :content="$t('downloadFile')"
                    v-if="showDownloadBtn(scope.row) && _.includes(['edit', 'read'], type)"
                    class="ml-10px"
                  >
                    <el-button
                      class="iconfont icon-line-download"
                      type="primary"
                      size="mini"
                      @click="downloadFile(scope.row)"
                    ></el-button>
                  </el-tooltip>
                  <el-tooltip
                    :content="$t('deleteFile')"
                    v-if="showDeleteBtn(scope.row) && _.includes(['edit'], type)"
                    class="ml-10px"
                  >
                    <el-button
                      class="iconfont icon-line-delete"
                      type="danger"
                      size="mini"
                      @click="deleteFile(scope.row, scope.row.code)"
                    ></el-button>
                  </el-tooltip>
                </div>
                <!-- 上级对象 start -->
                <el-select
                  v-else-if="!scope.row.isDynamicAttribute && scope.row.valueType === 4"
                  class="w-full"
                  v-model="scope.row.value"
                  clearable
                  filterable
                  v-selectloadmore:rangeNum="loadMore(rangeNum)"
                  :filter-method="dataFilter"
                  :placeholder="`${$t('pleaseSelect')}`"
                  @change="change"
                >
                  <el-option
                    v-for="item in scope.row.selectDataSource"
                    :key="item.id"
                    :label="item.code"
                    :value="item.code"
                  >
                    <span style="float: left">{{ item.code }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{
                      item.NameAttr
                    }}</span>
                  </el-option>
                </el-select>
                <!-- 上级对象 end -->
                <!-- 布尔类型 start-->
                <el-select
                  v-else-if="scope.row.isDynamicAttribute && scope.row.valueType === 4"
                  class="w-full"
                  v-model="scope.row.value"
                  clearable
                  filterable
                  :placeholder="`${$t('pleaseSelect')}`"
                  @change="change"
                >
                  <el-option :label="$t('yes')" value="是"> </el-option>
                  <el-option :label="$t('no')" value="否"> </el-option>
                </el-select>
                <!-- 布尔类型 end-->
                <!-- Enum类型(单选) / 枚举-多选类型（多选）  start-->
                <el-select
                  v-else-if="_.includes([5, 7], scope.row.valueType)"
                  class="w-full"
                  v-model="scope.row.value"
                  clearable
                  :multiple="scope.row.valueType === 7 ? true : false"
                  filterable
                  :placeholder="`${$t('pleaseSelect')}`"
                  @change="change"
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="(item, index) in referenceDataList"
                    :key="index"
                  >
                  </el-option>
                </el-select>
                <!-- Enum类型 end-->
                <el-select
                  v-else-if="!scope.row.ruleExpression && scope.row.refrenceAttributeId"
                  class="w-full"
                  v-model="scope.row.value"
                  clearable
                  filterable
                  v-selectloadmore:rangeNum="loadMore(rangeNum)"
                  :filter-method="dataFilter"
                  @focus="focus(scope.row)"
                  @change="change(scope.row)"
                  :placeholder="`${$t('pleaseSelect')}`"
                >
                  <el-option
                    v-for="(item, index) in !_.isEmpty(scope.row.transitList)
                      ? scope.row.transitList.slice(0, rangeNum)
                      : scope.row.transitList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{
                      item.NameAttr
                    }}</span>
                  </el-option>
                </el-select>
                <el-input
                  disabled
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      scope.row.columnName === 'approve_status'
                  "
                  v-model="scope.row.value"
                ></el-input>
                <el-select
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      scope.row.valueType === 11
                  "
                  class="w-full"
                  v-model="scope.row.value"
                  clearable
                  multiple
                  collapse-tags
                  filterable
                  @focus="focusMul(scope.row)"
                  @change="change(scope.row)"
                  :placeholder="`${$t('pleaseSelect')}`"
                >
                  <el-option
                    v-for="(item, index) in scope.row.transitList"
                    :key="index"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="scope.row.value"
                  class="w-full"
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      (scope.row.valueType === 1 || scope.row.valueType === 10)
                  "
                  @change="change"
                ></el-input>
                <el-input-number
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      (scope.row.valueType === 2 || scope.row.valueType === 3)
                  "
                  v-model="scope.row.value"
                  :controls="false"
                  class="w-full"
                  @change="change"
                ></el-input-number>
                <el-time-picker
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      scope.row.valueType === 9
                  "
                  v-model="scope.row.value"
                  class="!w-full"
                  :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59',
                  }"
                  @change="change(scope.row)"
                  value-format="HH:mm:ss"
                  :placeholder="`${$t('selectTime')}`"
                ></el-time-picker>
                <el-date-picker
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      scope.row.valueType === 8
                  "
                  v-model="scope.row.value"
                  class="!w-full"
                  value-format="yyyy-MM-dd"
                  type="date"
                  @change="change(scope.row)"
                  :placeholder="`${$t('selectDate')}`"
                ></el-date-picker>
                <el-date-picker
                  v-else-if="
                    !scope.row.ruleExpression &&
                      !scope.row.refrenceAttributeId &&
                      scope.row.valueType === 6
                  "
                  v-model="scope.row.value"
                  class="!w-full"
                  type="datetime"
                  @change="change(scope.row)"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="`${$t('selectTime')}`"
                ></el-date-picker>
                <span v-else>{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer tc" v-if="title !== $t('viewCode')">
        <el-button type="primary" @click="save" :disabled="disabledBtn">{{ $t('save') }}</el-button>
        <el-button @click="isShowDialog = false">
          {{ $t('cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :width="uploadFileTitle === $t('upload') ? '530px' : '1200px'"
      :top="isFullScreen ? '0' : '15vh'"
      id="viewDialog"
      :title="uploadFileTitle"
      :visible.sync="uploadFileVisible"
      v-dialogDrag
    >
      <i
        @click="fullScreen()"
        v-show="uploadFileTitle !== $t('upload')"
        v-if="!isFullScreen"
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <i
        v-show="uploadFileTitle !== $t('upload')"
        @click="exitFullScreen()"
        v-else
        class="iconfont icon-line-fullscreen cur-pointer position-absolute"
      ></i>
      <el-upload
        v-loading="uploadLoading"
        v-if="uploadFileTitle === $t('upload')"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
      >
        <i style="font-size: 67px" class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $t('onlyOne') }}
          <em>{{ $t('clickUpload') }}</em>
        </div>
      </el-upload>
      <div style="height: 520px" id="fileView" v-else v-loading="loadingFile">
        <img :src="viewUrl" class="w-full h-full" v-if="isImg" />
        <iframe v-else :src="viewUrl" class="w-full h-full"></iframe>
      </div>
    </el-dialog>
    <!-- 导入 -->
    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchCodeList"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
    <!-- 查看附件弹框 -->
    <AttachmentList
      v-if="attachmentListVisible"
      :visible="attachmentListVisible"
      :attachmentListTabList="attachmentListTabList"
      :valueList="currentValueList"
      :standardId="standardId"
      @closeAttachmentListDialog="closeAttachmentListDialog"
    ></AttachmentList>
    <!-- 高级查询 -->
    <advancedQueries
      :advancedQueriesProps="advancedQueriesProps"
      @updateAdvancedQueries="updateAdvancedQueries"
    ></advancedQueries>
  </div>
</template>

<script>
import ReferenceDataService from '@/services/ReferenceDataService'
import assetService from '@/services/assetService'
import documentManagementService from '@/services/documentManagement'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import stdClassListService from '@/services/stdClassListService'
import StdAttrBusinessOperation from '@/services/bsApi/StdAttributeBusinessOperation'
// import ColumnVisible from '@/components/ColumnVisible'
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'
import HandoverFormDialog from '../../components/handoverFormDialog'
import selectTree from '../onlineFilling/components/selectTree'
import AttachmentList from './components/attachmentList'
import advancedQueries from '../../components/advancedQueries'

export default {
  name: 'codeList',
  components: {
    // ColumnVisible,
    selectStandardId,
    HandoverFormDialog,
    selectTree,
    AttachmentList,
    advancedQueries,
  },
  mixins: [fnMixin],
  directives: {
    selectloadmore: {
      bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
        SELECTWRAP_DOM.addEventListener('scroll', () => {
          /**
           * scrollHeight 获取元素内容高度(只读)
           *scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0
           *clientHeight 读取元素的可见高度(只读)
           *如果元素滚动到底, 下面等式返回true, 没有则返回false
           *ele.scrollHeight - ele.scrollTop === ele.clientHeight
           */
          const condition =
            SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop <= SELECTWRAP_DOM.clientHeight
          if (condition) binding.value()
        })
      },
    },
  },
  data() {
    return {
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      advancedQueriesProps: {
        dialogVisible: false,
      },
      fileExt: ['pptx', 'ppt', 'xlsx', 'xls', 'doc', 'docx', 'txt'], // 转pdf的文件格式
      opereateList: [], // 当前操作列表
      historyHeader: [],
      turnOverLoading: false,
      saveLoading: false,
      transParams: {},
      currentSortParams: {
        orderby: '',
        orderbytype: '',
      }, // 排序查询条件
      historyList: [],
      historyVisible: false,
      flowId: '',
      selectedItem: [],
      totalSelection: [], // 存放跨页勾选的项
      executorList: [],
      // 状态下拉框
      statusOption: [
        {
          value: 0,
          label: '未发布',
        },
        {
          value: 1,
          label: '审核中',
        },
        {
          value: 2,
          label: '已作废',
        },
      ],
      // 流程审批 start
      turnOverList: [],
      turnOverRules: {
        title: [{ required: true, message: this.$t('titleCannotBeEmpty'), trigger: 'blur' }],
        flowClass: [
          { required: true, message: this.$t('processTypeCannotBeEmpty'), trigger: 'blur' },
        ],
        person: [{ required: true, message: this.$t('approverCannotBeEmpty'), trigger: 'change' }],
        completedtime: [
          { required: true, message: this.$t('deadlineCannotBeEmpty'), trigger: 'blur' },
        ],
      },
      statusList: [
        {
          value: 0,
          label: '未发布',
        },
        {
          value: 1,
          label: '审核中',
        },
        {
          value: 2,
          label: '已作废',
        },
      ],
      turnOverForm: {
        title: '',
        flowClass: '编码审批流程',
        completedtime: '',
        person: [],
        destinationFolderId: '',
        processUserId: '',
        flowStatus: '审核中',
        handOverFlowTaskDtos: [],
      },
      activeName: 'first',
      isShowTurnOver: false,
      // 流程审批 end
      isFullScreen: false,
      viewUrl: '',
      imgExt: ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tif'],
      uploadFileTitle: '上传',
      currentRow: null,
      file: null,
      uploadFileVisible: false,
      attrList: [],
      attrId: '',
      rangeNum: 100,
      exportLoading: false,
      title: '',
      pageNo: 0,
      pageSize: 15,
      recordCount: 0,
      changeType: '',
      listLoading: false,
      keyword: '',
      valueList: [],
      classId: '',
      isShowDialog: false,
      classList: [],
      attributeList: [],
      tableHeader: [],
      tableFilterHeader: [],
      columnVisibleOptions: [],
      columnVisible: [],
      standardId: localStorage.getItem('standardId'),
      disabledBtn: false,
      selectedId: '',
      symbolList: [
        { value: '=', name: '等于' },
        { value: '$ne', name: '不等于' },
        { value: '$gt', name: '大于' },
        { value: '$gte', name: '大于等于' },
        { value: '$lt', name: '小于' },
        { value: '$lte', name: '小于等于' },
        { value: '$text', name: '包含' },
        { value: '$ntext', name: '不包含' },
        // { value: '$in', name: '在范围内' },
        // { value: '$nin', name: '不在范围内' },
      ],
      labelArr: [],
      symbolValue: '',
      selectedAttrType: 1,
      transitListCopy: [],
      handleCode: '',
      themeList: [],
      themeId: '',
      stdClassName: '', // 实体名称
      loadingFile: false,
      isImg: false, // 是否图片
      browseItem: null, // 浏览文件
      currentCode: null,
      uploadLoading: false,
      uploadId: '',
      type: '', // 编辑才显示上传按钮，新增和查看不展示
      referenceDataList: [],
      hasUpload: false, // 是否上传
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      handoverFormProps: {
        dialogVisible: false, // form弹框显示状态
        standardId: localStorage.getItem('standardId'),
        tabs: [
          // form弹框tab显示
          // { name: '文档', label: '1' },
        ],
        rowData: null,
        isShowClassType: false, // 是否显示实体类型
        isDataDetail: true, // 是否实体数据管理
      },
      idsList: [],
      selectedRows: [],
      classPros: {
        label: 'code',
        children: 'children',
        isLeaf: (data) => {
          if (!data.isLeaf) {
            return true
          }
          return false
        },
      },
      tableClassData: [],
      classKeyword: '',
      isShowTooltip: false,
      isExpandAll: false,
      treeStandBy: true,
      isShowTreeMode: true,
      currentTreeSelected: {},
      isAttachment: false, // 是否附件列表
      attachmentListVisible: false,
      attachmentListTabList: [],
      currentValueList: {},
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters['Auth/userInfo']
    },
  },
  watch: {
    selectedAttrType() {
      this.keyword = ''
    },
    uploadFileVisible(bol) {
      if (!bol) {
        if (this.isFullScreen) {
          this.isFullScreen = false
          this.exitFullScreen()
        }
        this.uploadFileTitle = this.$t('upload')
      }
    },
    // 标准变化请求实体
    standardId(val) {
      this.themeId = ''
      this.themeList = []
      this.classId = ''
      this.classList = []
      this.attrId = ''
      this.attrList = []
      if (val) {
        // this.getThemeList()
        this.getClassTreeList()
      }
    },
    // themeId() {
    //   this.classId = ''
    //   this.classList = []
    //   this.attrId = ''
    //   this.attrList = []
    //   this.valueList = []
    //   this.getClassList()
    // },
    // 实体变化请求属性列表
    classId(val) {
      this.attrId = ''
      this.attrList = []
      // this.symbolValue = ''
      this.keyword = ''
      if (val) {
        this.getAttrList()
        this.findAttrConfig()
        this.getDynamicTableHeader()
        this.searchCodeList()
      }
    },
    // 属性变化请求明细列表
    attrId(val) {
      if (!val) {
        // this.symbolValue = ''
        this.keyword = ''
      } else {
        this.sortParams = null
        this.searchCodeList()
      }
    },
    attributeList: {
      handler(newVal) {
        _.map(newVal, (item) => {
          if (item.ruleExpression && (item.value === '' || item.value === null)) {
            item.value = item.ruleExpression
          }
        })
      },
      deep: true,
    },
  },
  async created() {
    await this.getSymbolList()
    if (this.standardId) {
      // this.getThemeList()
      this.getClassTreeList()
    }
  },
  // async mounted() {
  // let tableNode = document.getElementsByClassName("vxe-table--body")
  // tableNode[0].parentElement.addEventListener('scroll', () => {
  //   // console.log("激活节点事件parentElement", tableNode, tableNode[0].parentElement.scrollTop)
  //   if(tableNode[1] && tableNode[1].parentElement) {
  //     tableNode[1].parentElement.scrollTop = tableNode[0].parentElement.scrollTop - 0
  //     console.log("节点移动完成", tableNode[0].parentElement.scrollTop, tableNode[1].parentElement.scrollTop)
  //   }
  // })
  // },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
  methods: {
    // 高级查询弹框
    toMoreSearch() {
      this.advancedQueriesProps.dialogVisible = true
      this.advancedQueriesProps.standardId = this.standardId
      this.advancedQueriesProps.classIds = [this.classId]
    },
    // 高级查询保存
    updateAdvancedQueries(val) {
      this.advancedQueriesProps.dialogVisible = val.dialogVisible
      if (!val.conditionalModels) return
      this.searchCodeList('search', val.conditionalModels)
    },
    // 收缩实体树
    changeTreeMode() {
      this.isShowTreeMode = !this.isShowTreeMode
    },
    // 展开/合并目录树
    operateTree(bool) {
      this.isExpandAll = bool
      this.treeStandBy = false
      this.getClassTreeList()
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    // 实体树加载数据
    async loadClassTreeNode(node, resolve) {
      if (node.level > 0) {
        const parameter = {
          standard_id: this.standardId,
          keyword: this.classKeyword,
          std_class_type_attribute_cate_id: this.entityTypeId,
          data_type: this.classKeyword ? 1 : 0,
          parent_id: node.data?.id,
          approve_status: 1,
        }
        const res = await stdClassListService.getClassList(parameter)
        if (res && res.code === 0 && res.data) {
          this.nodeData = node
          this.resolveData = resolve
          return resolve(res.data)
        }
      }
      return resolve([])
    },
    // 获取实体树数据
    async getClassTreeList() {
      this.classListLoading = true
      const parameter = {
        standard_id: this.standardId,
        keyword: this.classKeyword,
        std_class_type_attribute_cate_id: '',
        data_type: this.classKeyword ? 1 : 0,
        approve_status: 1, // 1 已发布 0 未发布
      }
      const res = await stdClassListService.getClassList(parameter)
      this.classListLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableClassData = res.data
        if (!res.data.length) return
        this.$nextTick(() => {
          this.$refs.classTree.setCurrentKey(res.data[0].id)
          this.classNodeClick(res.data[0])
        })
      }
    },
    // 将接口返回的children添加到表格的data里
    handleChildren(childList, data, parentId) {
      childList.map((item) => {
        if (item.id === parentId) {
          item.children = data
        } else if (item.id !== parentId && item.children) {
          this.handleChildren(item.children, data, parentId)
        }
        return item
      })
    },
    renderSelectTable(initTableArr, selectionArr, domTable) {
      // 渲染选择的列表
      _.forEach(initTableArr, (item) => {
        if (_.find(selectionArr, ['id', item.parentId])) {
          this.$nextTick(() => {
            this.$refs[domTable].toggleRowSelection(item, true)
          })
        }
      })
    },
    // 实体树点击
    classNodeClick(data) {
      console.log('实体树点击', data)
      this.currentTreeSelected = data
      this.classId = data.id
      this.getClassTypeNameById(this.classId, data.name)
      this.stdClassName = data.name
    },
    // 是否显示提示信息框
    classTreeMouseOver(node) {
      const offsetWidth = document.querySelector(`.${node}`).offsetWidth
      const clientWidth = document.querySelector(`.${node}`).parentNode.clientWidth
      if (offsetWidth <= clientWidth) {
        this.isShowTooltip = true
      } else {
        this.isShowTooltip = false
      }
    },
    changeEntityData(val) {
      this.themeId = val
      this.classId = ''
      this.classList = []
      this.attrId = ''
      this.attrList = []
      this.valueList = []
      this.getClassList()
    },
    handleSelectionChangeVxe(val) {
      this.selectedRows = val.records
      this.idsList = _.map(val.records, (item) => {
        return item.id
      })
    },
    handleSelectionChange(val) {
      this.selectedRows = val
      this.idsList = _.map(val, (item) => {
        return item.id
      })
    },
    // 删除动态数据
    deleteDynamicData(rows) {
      if (rows.length > 0) {
        this.$confirm(this.$t('confirmToDelete'), this.$t('tip'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(async () => {
          const params = []
          _.map(rows, (item) => {
            params.push({
              type: 0,
              standardId: this.standardId,
              dataId: item.id,
              classId: this.classId,
            })
          })
          const res = await documentManagementService.deleteDynamicData(params)
          if (res && res.code === 0) {
            this.$message.success(this.$t('successfullyDeleted'))
            this.searchCodeList()
          }
        })
      } else {
        this.$message.warning(this.$t('PleaseSelectTheDataYouWantToDelete'))
      }
    },
    // 获取操作符
    async getSymbolList() {
      this.symbolList = []
      const res = await assetService.getSearchOperator()
      if (res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          this.symbolList.push({
            label: item.text,
            value: item.value,
          })
        })
        if (this.symbolList.length) {
          this.symbolValue = this.symbolList[6].value
        }
      }
    },
    // 获取实体数据管理动态表头
    async getDynamicTableHeader() {
      const res = await stdClassDataService.getDynamicTableHeader({ classId: this.classId })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
        console.log('动态表', this.tableHeader)
        // 判断是否是附件列表
        this.isAttachment = res.data.find((item) => {
          return item.valueType === 13
        })
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const res = await documentManagementService.downloadTemplate({
        standardId: this.standardId,
        cateCode: '',
        classIds: [this.classId],
      })
      // 返回的是文件流
      if (res) {
        this.downLoadBlob({
          name: `${this.stdClassName}-数据明细导入模板.xlsx`,
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append(key, value)
      })
      formData.append('standardId', this.standardId)
      formData.append('cateCode', '')
      formData.append('classId', this.classId)
      const res = await documentManagementService.importDynamicTableData(formData)
      if (res) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: `${this.stdClassName}-数据明细导入明细.xlsx`,
          data: res,
        })
        this.searchCodeList()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 获取参考数据
    async getReferenceData(id) {
      const params = {
        SkipCount: 0,
        MaxResultCount: 999,
        cateId: id,
      }
      const res = await ReferenceDataService.getCategoryItem(params)
      if (res && res.code === 0 && res.data) {
        this.referenceDataList = res.data
      }
    },
    updateStandardId(val) {
      this.standardId = val
      this.handoverFormProps.standardId = val
    },
    // 修改实体id
    changeClassId(val) {
      this.currentSortParams = {
        orderby: '',
        orderbytype: '',
      }
      const className = _.find(this.classList, { id: val })
      if (className) this.stdClassName = className.name
      this.getClassTypeNameById(val, this.stdClassName)
    },
    showUploadBtn(column) {
      // 上传按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '上传文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showViewBtn(column) {
      // 查看按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '打开文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showDownloadBtn(column) {
      // 下载按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '下载文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    showDeleteBtn(column) {
      // 删除按钮
      const uploadOperateAttr = _.find(column.opereateList, ['businessOperationName', '删除文件'])
      if (_.isNil(uploadOperateAttr)) {
        return false
      }
      if (uploadOperateAttr.presentationTypeStr === '列按钮') {
        return true
      }
      return false
    },
    deleteFile(row, code) {
      this.currentCode = code
      this.currentRow = row
      if (!row.value) {
        this.$message.warning('未上传文件')
        return
      }
      this.$confirm(this.$t('confirmToDeleteForever'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      }).then(async () => {
        const res = await assetService.deleteFile({ ownerId: this.selectedId })
        if (res && res.code === 0) {
          this.$message.success(this.$t('successfullyDeleted'))
          this.getFileId(row.stdClassAttributeId)
        }
      })
    },
    downloadFile(column) {
      // 下载文件
      if (!column.value) {
        this.$message.warning('未上传文件')
        return
      }
      const index = column.value.lastIndexOf('.')
      const fileName = column.value.slice(0, index)
      window.location.href = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
    },
    operateColumn(column) {
      // 附加在文本
      const isAddedInText = _.find(column.opereateList, ['presentationTypeStr', '附加在文本'])
      if (_.isNil(isAddedInText)) {
        return
      }
      if (isAddedInText.businessOperationName === '打开文件') {
        this.viewFile(column)
        return
      }
      if (isAddedInText.businessOperationName === '下载文件') {
        const index = column.value.lastIndexOf('.')
        const fileName = column.value.slice(0, index)
        window.location.href = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
      }
    },
    computeOperataTableList(row, label) {
      let viewFile = false
      let downloadFile = false
      _.forEach(this.opereateList, (item) => {
        if (
          item.attributeName === label &&
          item.businessOperationName === '打开文件' &&
          item.presentationTypeStr === '附加在文本'
        ) {
          viewFile = true
          return false
        }
        if (
          item.attributeName === label &&
          item.businessOperationName === '下载文件' &&
          item.presentationTypeStr === '附加在文本'
        ) {
          downloadFile = true
          return false
        }
      })
      return viewFile || downloadFile
    },
    operateTableList(row, label, prop) {
      // 配置操作列表
      let viewFile = false
      _.forEach(this.opereateList, (item) => {
        if (
          item.attributeName === label &&
          item.businessOperationName === '打开文件' &&
          item.presentationTypeStr === '附加在文本'
        ) {
          viewFile = true
          return false
        }
        if (
          item.attributeName === label &&
          item.businessOperationName === '下载文件' &&
          item.presentationTypeStr === '附加在文本'
        ) {
          return false
        }
        return null
      })
      if (viewFile) {
        // 查看文件
        this.viewFile({
          value: row[prop],
        })
        return
      }
      const index = row[prop].lastIndexOf('.')
      const fileName = row[prop].slice(0, index)
      // 下载文件
      window.location.href = `${this.currentEnv.VUE_APP_UPLOAD_SERVER}/api/Common/file?downloadType=1&target=${fileName}&type=0`
    },
    // 关闭编码历史
    closeHistory() {
      this.$route.query.itemId ? (this.historyVisible = true) : (this.historyVisible = false)
      this.historyList = []
    },
    changeColumn(data) {
      if (data.length === 0 && this.tableFilterHeader.length === 1) {
        this.$message({
          type: 'warning',
          message: this.$t('pleaseSelectAtLeaseOneTableHeader'),
        })
        return
      }
      this.columnVisible = data
      this.tableFilterHeader = _.filter(this.tableHeader, (item) => {
        return _.includes(data, item.code)
      })
      this.$nextTick(() => {
        if (this.$refs.table) {
          // this.$refs.table.doLayout()
          this.$refs.table.refreshColumn()
          this.$refs.table.recalculate(true)
          this.$refs.table.refreshScroll()
        }
      })
    },
    fullScreen() {
      this.isFullScreen = true
      this.launchFullscreen(document.getElementById('viewDialog'))
    },
    exitFullScreen() {
      this.isFullScreen = false
      this.exitFullscreen()
      if (this.uploadFileTitle === this.$t('upload')) {
        $('.el-dialog')
          .width(530)
          .height(344)
        $('#fileView').height(215)
        return
      }
      $('.el-dialog')
        .width(1200)
        .height(600)
      $('#fileView').height(515)
    },
    // 判断各种浏览器，找到正确的方法
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      }
      $('.el-dialog')
        .width(window.screen.width)
        .height(window.screen.height)
      $('#fileView').height(window.screen.height - 100)
    },
    // 判断浏览器种类
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    async viewFile(row, type, column) {
      if (type === 'isView') {
        this.selectedId = row.id
        let stdClassAttributeId = null
        _.map(this.attrList, (item) => {
          if (item.columnName === column) stdClassAttributeId = item.stdClassAttributeId
        })
        await this.getFileId(stdClassAttributeId)
      } else {
        await this.getFileId(row.stdClassAttributeId)
      }
      if (this.browseItem !== null) {
        $('#viewDialog .el-dialog').height(600)
        this.uploadFileTitle = this.$t('view')
        this.uploadFileVisible = true
        this.loadingFile = true
        // 通过fileId拿到返回的文件流
        if (_.includes(this.imgExt, this.browseItem.fileType.split('.')[1])) {
          // png
          this.isImg = true
          const resData = await assetService.browsePNG({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'image/jpeg' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        } else {
          // pdf
          this.isImg = false
          const resData = await assetService.browsePDF({ fileId: this.browseItem.fileId })
          if (resData) {
            const blob = new Blob([resData], { type: 'application/pdf' })
            const url = window.URL.createObjectURL(blob)
            this.viewUrl = url
            this.loadingFile = false
          }
        }
      } else {
        this.$message.warning('没有上传文件')
      }
    },
    // 新增的时候上传图片，先保存数据，再上传图片
    addUpload() {
      this.$set(this.currentRow, 'value', this.file.name)
      _.map(this.attributeList, (item, index) => {
        if (item.code === this.currentCode) {
          this.$set(this.attributeList, index, this.currentRow)
        }
      })
      this.$message.success(this.$t('uploadSuccess'))
      this.hasUpload = true
      this.uploadFileVisible = false
    },
    // 编辑的时候上传图片
    async editUpload() {
      // 上传文件前要先把之前上传的先给删掉
      this.uploadLoading = true
      if (this.browseItem !== null) {
        const delRes = await assetService.deleteFile({ ownerId: this.selectedId })
        if (delRes) console.log('删除成功')
      }
      const formData = new FormData()
      _.forIn({ file: this.file }, (value, key) => {
        formData.append(key, value)
      })
      const fileType = _.split(this.file.name, '.')[1]
      if (_.includes(this.fileExt, fileType)) {
        formData.append('Type', 1) // Type为1需要转成pdf
      } else {
        formData.append('Type', 0) // Type为0不需要转
      }
      formData.append('Id', this.selectedId)
      formData.append('StepId', this.uploadId) // 步骤或字段属性id
      const res = await assetService.uploadFile({
        reqData: formData,
      })
      this.uploadLoading = false
      if (res) {
        if (this.type !== 'add') {
          this.$message.success(this.$t('uploadSuccess'))
        }
        if (_.includes([...this.imgExt, 'pdf'], res[res.length - 1].fileType.split('.')[1])) {
          this.browseItem = res[res.length - 1]
        } else {
          this.browseItem = res[res.length - 1]
        }
        this.$set(this.currentRow, 'value', this.browseItem.name)
        _.map(this.attributeList, (item, index) => {
          if (item.code === this.currentCode) {
            this.$set(this.attributeList, index, this.currentRow)
          }
        })
        this.uploadFileVisible = false
      }
    },
    // 上传操作
    async uploadExcel() {
      if (this.type === 'add') {
        this.addUpload()
      } else {
        this.editUpload()
      }
    },
    getFileContent(file) {
      this.file = file
    },
    uploadFile(row, code) {
      $('#viewDialog .el-dialog').height(344)
      $('#fileView').height(215)
      this.currentCode = code
      this.currentRow = row
      this.uploadFileTitle = this.$t('upload')
      this.uploadFileVisible = true
      this.uploadId = row.stdClassAttributeId
    },
    loadMore() {
      return () => {
        this.rangeNum += 50
      }
    },
    dataFilter(val) {
      const arr = this.transitListCopy.filter((item) => {
        return item.name.indexOf(val) !== -1
      })
      if (val) {
        this.attributeList.forEach((item) => {
          if (this.handleCode === item.code) {
            this.$set(item, 'transitList', arr)
          }
        })
      } else {
        this.attributeList.forEach((item) => {
          if (this.handleCode === item.code) {
            this.$set(item, 'transitList', this.transitListCopy)
          }
        })
      }
    },
    // 文件导出
    exportExcel() {
      this.$confirm(this.$t('confirmToContinueAwaite'), `${this.$t('hint')}?`, {
        confirmButtonText: `${this.$t('Sure')}`,
        cancelButtonText: `${this.$t('Cancel')}`,
        type: 'warning',
      }).then(() => {
        this.exportDynamicTableData()
      })
    },
    // 动态表格导出数据
    async exportDynamicTableData() {
      this.exportLoading = true
      const res = await documentManagementService.exportDynamicTableData({
        standardId: this.standardId,
        cateCode: '',
        classIds: [this.classId],
        ids: this.idsList,
        classAttributeId: this.attrId,
        operator: this.symbolValue,
        keywords: this.keyword,
      })
      this.exportLoading = false
      if (res) {
        this.downLoadExcel(`${this.stdClassName}-数据明细导出结果.xlsx`, res)
      }
    },
    // 根据需求导出的是当前实体的所有数据明细
    async exportFile() {
      this.exportLoading = true
      let url = ''
      // 当属性类行为标签类型（11），需要额外的参数
      if (this.selectedAttrType !== 11 && (this.symbolValue === '=' || this.symbolValue === '')) {
        url = `?class_id=${this.classId}&${this.attrId}=${this.keyword}`
      } else if (
        this.selectedAttrType !== 11 &&
        (this.symbolValue !== '=' || this.symbolValue !== '')
      ) {
        url = `?class_id=${this.classId}&${this.attrId}[${this.symbolValue}]=${this.keyword}`
      } else {
        url = `?class_id=${this.classId}&tagcolumn=${this.attrId}&tagvalue=${this.keyword},`
      }
      const res = await stdClassDataService.exportData({
        urlParam: `${url}&isAddTagOrDocument=true`, // isAddTagOrDocument=true 代表要带上位号或文档的值
        ids: [],
      })
      if (res) {
        this.downLoadExcel(`${this.stdClassName}-数据明细导出结果.xlsx`, res)
      }
      this.exportLoading = false
    },
    // 获取主题列表
    async getThemeList() {
      const parameter = {
        standard_id: this.standardId,
        pageno: 1,
        pagesize: 999,
      }
      const res = await StdSubjectDomainService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.themeList = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
        // if (this.themeList.length) {
        //   this.themeId = this.themeList[0].id
        // }
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        data_type: 1,
        standard_id: this.standardId,
        subject_domain_id: this.themeId,
        approve_status: 1, // 已发布
        is_type: false, // 是否为类型
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
        if (this.classList.length) {
          this.classId = this.classList[0].id
          this.getClassTypeNameById(this.classId, this.classList[0].name)
          this.stdClassName = this.classList[0].name
        }
      }
    },
    // 新增弹窗里获取属性列表
    async searchAttribute() {
      this.attributeList = []
      this.listLoading = true
      const parameter = {
        classId: this.classId,
      }
      const res = await stdClassDataService.getInsertData(parameter)
      if (res && res.code === 0 && res.data) {
        if (res.data.attributeList.length > 0 && res.data.tagOrDocumentAttributes === null) {
          this.attributeList = res.data.attributeList
        }
        if (res.data.attributeList === null && res.data.tagOrDocumentAttributes.length > 0) {
          this.attributeList = res.data.tagOrDocumentAttributes
        }
        if (res.data.attributeList && res.data.tagOrDocumentAttributes) {
          this.attributeList = res.data.tagOrDocumentAttributes.concat(res.data.attributeList)
        }
        this.listLoading = false
        this.attributeList.forEach((item) => {
          if (item.refrenceAttributeId) {
            this.$set(item, 'transitList', [])
          }
          // valueType=5是enum类型，valueType =7是枚举-多选类型
          if (_.includes([5, 7], item.valueType) && item.referenceDataClassId) {
            this.getReferenceData(item.referenceDataClassId)
          }
        })
      }
    },
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attrList = res.data
        if (this.attrList.length) {
          this.attrId = this.attrList[0].id
          // this.selectedAttrType = this.attrList[0].valueType
        }
      }
    },
    async getTotalCount(parameter) {
      // 获取页码数
      this.recordCount = 0
      const res = await stdClassDataService.getPagedCount(parameter)
      if (res) {
        this.recordCount = res
      }
    },
    // 获取编码列表
    async searchCodeList(type, conditionalModels) {
      if (!this.classId) {
        this.$message({
          message: this.$t('pleaseSelectClass'),
          type: 'warning',
        })
        return
      }
      if (type === 'search') this.pageNo = 1
      // if (!this.attrId) {
      //   this.$message({
      //     message: this.$t('pleaseSelectAttr'),
      //     type: 'warning',
      //   })
      //   return
      // }
      this.listLoading = true
      const parameter = {
        classId: this.classId,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        // isAddTagOrDocument: true, // 带上位号或文档的值
        whereList: [],
        classAttributeId: this.attrId,
        operator: this.symbolValue,
        keywords: this.keyword,
        Sorting: `${this.currentSortParams.orderby} ${this.currentSortParams.orderbytype}`,
        conditionalModels,
        ExcludeTotalCount: true,
      }
      this.getTotalCount(parameter)
      // if (!_.isNil(this.currentSortParams)) {
      //   parameter = _.assign(parameter, this.currentSortParams)
      // }
      // if (this.attrId) {
      //   // 当属性类行为标签类型（11），需要额外的参数
      //   if (this.selectedAttrType !== 11 && (this.symbolValue === '='
      // || this.symbolValue === '')) {
      //     parameter[this.attrId] = this.keyword
      //   } else if (
      //     this.selectedAttrType !== 11 &&
      //     (this.symbolValue !== '=' || this.symbolValue !== '')
      //   ) {
      //     const obj = {}
      //     obj[this.symbolValue] = this.keyword
      //     parameter[this.attrId] = obj
      //   } else {
      //     parameter.tagcolumn = this.attrId
      //     parameter.tagvalue = `${this.keyword},`
      //   }
      // }
      // 当搜索审批状态时，处理状态值
      // if (this.attrId === 'approve_status') {
      //   switch (parameter.approve_status) {
      //     case this.$t('unreleased'):
      //       parameter.approve_status = 0
      //       break
      //     case this.$t('auditing'):
      //       parameter.approve_status = 1
      //       break
      //     case this.$t('handedOver'):
      //       parameter.approve_status = 2
      //       break
      //     case this.$t('canceled'):
      //       parameter.approve_status = 3
      //       break
      //     default:
      //       break
      //   }
      // }
      const res = await stdClassDataService.getDynamicTableData(parameter)
      this.listLoading = false
      if (res && res.code === 0 && res.data) {
        this.valueList = _.cloneDeep(res.data)
        this.$nextTick(() => {
          if (this.$refs.table) {
            // this.$refs.table.doLayout()
            this.$refs.table.refreshColumn()
            this.$refs.table.recalculate(true)
            this.$refs.table.refreshScroll()
          }
        })
        // this.tableHeader = []
        // if (res.data.headers.length) {
        //   res.data.headers.forEach((item) => {
        //     const obj = {}
        //     obj.label = item.name
        //     obj.column = item.column
        //     obj.code = item.code
        //     obj.value = item.code
        //     this.tableHeader.push(obj)
        //   })
        //   this.columnVisible = res.data.headers.map((item) => {
        //     return item.code
        //   })
        //   // 默认不显示审核人和审核时间
        //   _.forEach(this.columnVisible, (item, index) => {
        //     if (item === 'review' || item === 'audit_time') {
        //       delete this.columnVisible[index]
        //     }
        //   })
        // }
        // this.columnVisibleOptions = this.tableHeader
        // if (this.$refs.columnVisible) {
        //   this.$refs.columnVisible.columnVisible = this.columnVisible
        // }
        // this.changeColumn(this.columnVisible)
        // 处理状态的值
        // if (res.data.datas.length) {
        //   res.data.datas.forEach((item) => {
        //     switch (item.approve_status) {
        //       case 0:
        //         item.approve_status = this.$t('unreleased')
        //         break
        //       case 1:
        //         item.approve_status = this.$t('auditing')
        //         break
        //       case 2:
        //         item.approve_status = this.$t('handedOver')
        //         break
        //       case 3:
        //         item.approve_status = this.$t('canceled')
        //         break
        //       default:
        //         break
        //     }
        //   })
        // }
        // valueType === 8为日期格式，单独处理
        // this.valueList = _.map(res.data.datas, (item) => {
        //   _.map(res.data.headers, (hItem) => {
        //     Object.keys(item).forEach((key) => {
        //       if (key === hItem.column && hItem.valueType === 8 && item[key]) {
        //         item[key] = item[key].slice(0, 10)
        //       }
        //     })
        //   })
        //   return item
        // })
        // 判断是否为操作列
        // _.forEach(this.tableHeader, (item) => {
        //   item.opereateList = []
        //   _.forEach(this.opereateList, (cItem) => {
        //     if (cItem.attributeName === item.label) {
        //       this.$set(item, 'isOperate', true)
        //       item.opereateList = [...item.opereateList, cItem]
        //     }
        //   })
        // })
      } else {
        this.valueList = []
        this.recordCount = 0
      }
    },
    // 新增弹窗里下拉框获取焦点时请求下拉数据
    async focus(row) {
      this.handleCode = row.code
      if (row.transitList && row.transitList.length) {
        return
      }
      this.disabledBtn = true
      const parameter = {
        refrenceAttributeId: row.refrenceAttributeId,
      }
      const res = await stdClassDataService.getRefrenceData(parameter)
      if (res && res.code === 0 && res.data) {
        row.transitList = res.data
        this.transitListCopy = res.data
        this.$forceUpdate()
      }
      this.disabledBtn = false
    },
    async focusMul(row) {
      this.disabledBtn = true
      const parameter = {
        classId: row.classId,
      }
      const res = await stdClassDataService.getTagAttrList(parameter)
      if (res && res.code === 0 && res.data) {
        this.disabledBtn = false
        row.transitList = res.data
        this.$forceUpdate()
      }
    },
    // 查看
    async viewCode(id, stdClassAttributeId) {
      this.type = 'read'
      this.selectedId = id
      await this.getFileId(stdClassAttributeId)
      this.title = this.$t('viewCode')
      this.isShowDialog = true
      this.attributeList = []
      this.getDataById(id)
    },
    async getDataById(id) {
      const parameter = {
        classId: this.classId,
        dataId: id,
      }
      const res = await stdClassDataService.getDataById(parameter)
      if (res && res.code === 0 && res.data) {
        if (res.data.attributeList.length > 0 && res.data.tagOrDocumentAttributes === null) {
          this.attributeList = res.data.attributeList
        }
        if (res.data.attributeList === null && res.data.tagOrDocumentAttributes.length > 0) {
          this.attributeList = res.data.tagOrDocumentAttributes
        }
        if (res.data.attributeList && res.data.tagOrDocumentAttributes) {
          this.attributeList = res.data.tagOrDocumentAttributes.concat(res.data.attributeList)
        }
        this.attributeList.forEach((item) => {
          // valueType=5是enum类型，valueType =7是枚举-多选类型
          if (_.includes([5, 7], item.valueType) && item.referenceDataClassId) {
            this.getReferenceData(item.referenceDataClassId)
          }
          // valueType=9是时间格式，单独处理
          if (item.valueType === 9 && item.value) {
            item.value = item.value.slice(11, 19)
          }
          if (item.columnName === 'approve_status') {
            item.valueType = 1
            if (item.value === '0') {
              item.value = this.$t('unreleased')
            } else if (item.value === '1') {
              item.value = this.$t('auditing')
            } else if (item.value === '2') {
              item.value = this.$t('handedOver')
            } else {
              item.value = this.$t('canceled')
            }
          }
          if (item.value && item.value.endsWith(',')) {
            item.value = item.value.split(',')
            item.value.pop()
          }
          return item
        })
        this.upDateAttributeList()
      }
    },
    // 编辑
    async updateCode(id, stdClassAttributeId) {
      this.type = 'edit'
      this.title = this.$t('editCode')
      this.isShowDialog = true
      this.attributeList = []
      this.selectedId = id
      await this.getFileId(stdClassAttributeId)
      this.getDataById(id)
    },
    async getFileId(id) {
      // 1.先通过当前记录的id拿到fileId
      const res = await assetService.getFileId({ ownerId: this.selectedId, stepId: id })
      if (res.length > 0) {
        this.browseItem = res[res.length - 1]
      } else {
        this.browseItem = null
        // this.$set(this.currentRow, 'value', '')
        _.map(this.attributeList, (item, index) => {
          if (item.code === this.currentCode) {
            this.$set(this.attributeList[index], 'value', '')
          }
        })
      }
    },
    // 创建编码
    async save() {
      let flag = true
      const arr = _.cloneDeep(this.attributeList)
      _.forEach(arr, (item, index) => {
        if (item.transitList && item.transitList.length > 0) {
          delete item.transitList
        }
        if (Array.isArray(item.value) && item.value.length === 0) {
          item.value = ''
        }
        if (Array.isArray(item.value) && item.value.length >= 1) {
          item.value = `${item.value.join()},`
        }
        if (item.columnName === 'approve_status') {
          item.value = 0
        }
        if (item.isNullable && !item.value) {
          this.$message({
            message: `${this.$t('pleaseSelectOrEnder')} ${index + 1} ${this.$t(
              'classAttributeValue'
            )}`,
            type: 'warning',
          })
          flag = false
          return false
        }
        if (item.ruleExpression && item.value.includes('{{')) {
          this.$message.warning(this.$t('ruleExpressionsTips'))
          flag = false
          return false
        }
      })
      if (!flag) {
        return
      }
      this.listLoading = true
      const tagOrDocumentAttributes = []
      const attributeList = []
      _.map(arr, (item) => {
        if (item.isDynamicAttribute) {
          attributeList.push(item)
        } else {
          tagOrDocumentAttributes.push(item)
        }
      })
      const parameter = { attributeList, tagOrDocumentAttributes }
      // 新增
      if (this.title === this.$t('createCode')) {
        const res = await stdClassDataService.insertDataDetail(parameter)
        if (res && res.code === 0) {
          this.selectedId = res.data.dataId
          this.$message({
            message: res.msg,
            type: 'success',
          })
          if (this.hasUpload) {
            this.editUpload()
          }
          this.isShowDialog = false
          this.attributeList = []
          this.searchCodeList()
        }
      } else {
        // 编辑
        parameter.dataId = this.selectedId
        // 处理参数
        _.forEach(parameter.attributeList, (item) => {
          switch (item.value) {
            case this.$t('unreleased'):
              item.value = 0
              break
            case this.$t('auditing'):
              item.value = 1
              break
            case this.$t('handedOver'):
              item.value = 2
              break
            case this.$t('canceled'):
              item.value = 3
              break
            default:
              break
          }
        })
        const res = await stdClassDataService.updateDataDetail(parameter)
        if (res && res.code === 0) {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.isShowDialog = false
          this.attributeList = []
          this.searchCodeList()
        }
      }
      this.listLoading = false
    },
    sortChangeVxe(row) {
      this.currentSortParams = {
        orderby: row.property,
        orderbytype: row.order,
      }
      this.searchCodeList()
    },
    sortChangeLog(row) {
      let orderbytype = ''
      switch (row.order) {
        case 'ascending':
          orderbytype = 'asc'
          break
        case 'descending':
          orderbytype = 'desc'
          break
        default:
          orderbytype = ''
          break
      }
      this.currentSortParams = {
        orderby: row.prop,
        orderbytype,
      }
      this.searchCodeList()
    },
    selectionChangeLog() {},
    // 改变页数
    handleCurrentChange(num) {
      this.pageNo = num
      this.searchCodeList()
    },
    // 改变每页条数
    handleSizeChange(size) {
      this.pageSize = size
      this.searchCodeList()
    },
    // 打开新增编码弹窗
    async addEntity(row, type) {
      if (!this.classId) {
        this.$message.warning(this.$t('pleaseSelectClass'))
        return
      }
      this.handoverFormProps.rowData = row
      this.handoverFormProps.rowData.classId = this.classId
      this.handoverFormProps.dialogVisible = true
      if (type) {
        this.handoverFormProps.type = type
      }
      // this.type = 'add'
      // if (this.classId) {
      //   await this.searchAttribute()
      //   this.isShowDialog = true
      //   this.title = this.$t('createCode')
      //   this.upDateAttributeList()
      // } else {
      //   this.$message({
      //     message: this.$t('pleaseSelectClass'),
      //     type: 'warning',
      //   })
      // }
    },
    // 新增弹框子组件传参
    handoverFormEmit(val) {
      if (val) {
        this.handoverFormProps.dialogVisible = val.dialogVisible
        this.searchCodeList()
      }
    },
    // 根据id获取实体类型名称
    async getClassTypeNameById(id, name) {
      const res = await documentManagementService.getClassTypeNameById({
        id,
      })
      if (res && res.code === 0) {
        this.handoverFormProps.classId = id
        if (res.data && _.includes(['对象', '文档'], res.data)) {
          this.handoverFormProps.tabs = [
            { name: res.data === '对象' ? '位号' : '文档', label: '1' },
            { name, label: '2' },
          ]
        } else if (res.data && !_.includes(['对象', '文档'], res.data)) {
          this.handoverFormProps.tabs = [
            { name: res.data, label: '1' },
            { name, label: '2' },
          ]
        } else if (!res.data) {
          this.handoverFormProps.tabs = [{ name, label: '2' }]
        }
      }
    },
    upDateAttributeList() {
      // 更新编码列表
      // 判断是否为操作列
      _.forEach(this.attributeList, (item) => {
        item.opereateList = []
        _.forEach(this.opereateList, (cItem) => {
          if (cItem.attributeName === item.name) {
            this.$set(item, 'isOperate', true)
            item.opereateList = [...item.opereateList, cItem]
          }
        })
      })
    },
    async findAttrConfig() {
      // 获取属性配置信息
      const res = await StdAttrBusinessOperation.find({
        class_id: this.classId,
        pageno: 1,
        pagesize: 999,
        standard_id: this.standardId,
        attribute_id: '',
      })
      if (res && res.code === 0 && res.data) {
        this.opereateList = res.data
      }
    },
    // 删除编码
    deleteCode(id) {
      this.$confirm(this.$t('deleteTheCode'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(async () => {
          const parameter = {
            classId: this.classId,
            dataId: id,
          }
          const res = await stdClassDataService.deleteDataDetail(parameter)
          if (res && res.code === 0) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.searchCodeList()
          }
        })
        .catch(() => {})
    },
    async changeAttr(value) {
      if (!value) {
        return
      }
      this.keyword = ''
      // this.attrList.forEach((item) => {
      //   if (item.columnName === value) {
      //     this.selectedAttrType = item.valueType
      //     // 选中审批状态，改变输入框类型
      //     if (item.code === 'approve_status') {
      //       this.selectedAttrType = 1
      //     }
      //   }
      // })
      // if (this.selectedAttrType === 11) {
      //   const parameter = {
      //     classId: this.classId,
      //   }
      //   const res = await stdClassDataService.getTagAttrList(parameter)
      //   if (res && res.code === 0 && res.data) {
      //     this.labelArr = res.data
      //   }
      // }
    },
    blur() {
      this.change()
    },
    async change() {
      // 配置了ruleExpression规则表达式的，需要替换对应value
      _.map(this.attributeList, (item) => {
        if (item.ruleExpression && item.value) {
          _.map(this.attributeList, (aItem) => {
            if (item.value.includes(aItem.code) && aItem.value !== '' && aItem.value !== null) {
              item.value = item.value.replace(`{{${aItem.code}}}`, aItem.value)
            }
          })
        }
      })
      // ruleExpression不存在不允许调接口
      const ruleList = _.filter(this.attributeList, (item) => {
        return item.ruleExpression !== '' && item.ruleExpression !== null
      })
      if (ruleList.length === 0) {
        return
      }
      const parameter = {
        ClassId: this.classId,
        Items: [],
      }
      // 过滤数组
      const arr = _.cloneDeep(this.attributeList)
      const arr1 = arr.filter((item) => {
        return (
          item.ruleExpression !== '' &&
          item.ruleExpression !== null &&
          item.value !== '' &&
          item.value !== null
        )
      })
      // 组合参数
      _.forEach(arr1, (item) => {
        const obj = {}
        obj.classAttributeCode = item.code
        obj.value = item.value
        parameter.Items.push(obj)
      })
      const res = await stdClassDataService.getcode(parameter)
      if (res && res.code === 0 && res.data) {
        // 反显代码
        this.attributeList.forEach((item, index) => {
          res.data.forEach((it) => {
            if (item.code === it.item) {
              this.attributeList[index].value = it.code
            }
          })
        })
      }
    },
    // 查看附件
    viewAttachments(row) {
      console.log(row, this.tableHeader, '查看附件')
      this.attachmentListVisible = true
      this.attachmentListTabList = this.tableHeader.filter((item) => {
        return item.valueType === 13
      })
      this.currentValueList = row
    },
    // 关闭附件弹框
    closeAttachmentListDialog() {
      this.attachmentListVisible = false
      this.searchCodeList()
    },
  },
}
</script>

<style lang="scss" scoped>

.icon-line-fullscreen {
  top: 23px;
  right: 45px;
}
.position-absolute {
  position: absolute;
}
.historyTable {
  height: 80vh;
}
.handover-badge {
  margin-left: 10px;
  margin-right: 10px;
}
.examine {
  width: 80%;
  margin: 0 auto;
}
.turn-over-dialog {
  height: 42vh;
}
/deep/.el-dialog__body {
  padding: 20px;
}
/deep/.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
.underline {
  text-decoration: underline;
}
.icon-bg-circleLeft:before,
.icon-bg-circleRight:before {
  color: var(--buttonPrimaryBg);
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-tree-node__content {
  height: 32px !important;
  line-height: 32px !important;
}
/deep/ .vxe-table .vxe-table--main-wrapper {
  height: 100%;
}
/deep/ .vxe-table .vxe-table--main-wrapper .vxe-table--body-wrapper {
  max-height: calc(100% - 48px) !important;
  height: calc(100% - 48px);
}
/deep/ .vxe-table .vxe-table--body-wrapper.fixed-right--wrapper {
  max-height: calc(100% - 48px) !important;
  height: calc(100% - 48px);
}
/deep/ .vxe-table .vxe-table--body-wrapper.fixed-left--wrapper {
  max-height: calc(100% - 48px) !important;
  height: calc(100% - 48px);
}
/deep/ .col--last.right-fixed-row {
  visibility: visible !important;
  // position: fixed;
  // right: 0px;
  // float: right;
  height: 48px;
}
/deep/ .vxe-table .vxe-body--row.row--checked {
  background-color: transparent;
}
// /deep/ .vxe-body--row:hover .vxe-body--column {
//   background-color: var(--tableSelectColor)!important;
// }
.w-200px {
  width: 200px;
}
.w-280px {
  width: 280px;
}

</style>
